module.exports = __webpack_public_path__ + "img/banner2.a6f8260.png";